import { FunctionComponent } from "react";

/** component for banner per node type */
const _bannerHandler: Record<string, FunctionComponent> = {};

/** get the component based on the node type */
export function getBannerComponent(nodeType: string): FunctionComponent {
	return _bannerHandler[nodeType];
}

/** register the banner per node type */
export function registerBanner(nodeType: string, component: FunctionComponent): void {
	_bannerHandler[nodeType] = component;
}